function clickSize(element){
  if(element.getAttribute('data-option-type') != 'Color'){
    let label = $(element).parent();
    if(!label.hasClass("disabled")){
      $("label.swatch").removeClass("selected");
      label.addClass("selected");
  
      var variantId = element.getAttribute('data-variant-id');
      /* If variantId */
      if (variantId) {
         fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          return fetch(`/cart?sections=cart-drawer,cart-icon`);
        })
        .then(response => response.json())
        .then(data => {
          renderContents(data);
          getInfoCart();
          notesToggle(); //Load notes function
          removeProductEvent(); //Load remove function
          
        })
        .catch(error => console.error('Error:', error));
      }
      /* End if variantId */
    }
  }
}

function getInfoCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(cart => {
    let element = document.querySelector('.cart-drawer .side-panel-footer');
    if (element && element.classList.contains('hide')) {
        element.classList.remove('hide');
    }
    
    document.querySelector('.thb-item-count').textContent = cart.item_count;
  })
  .catch(error => console.error('Error al actualizar el carrito:', error));
}

document.addEventListener("DOMContentLoaded", () => {
  document.getElementById('cart-drawer-toggle').addEventListener('click', function() {
    document.getElementById('Cart-Drawer').classList.add('active');
  });
});

function updateFreeShipping(){
    const free_shipping = document.querySelector('.free-shipping');
    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text .free-shipping-remain span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;
        if (amount_text) {
          let remaining = minimum - total, format = window.theme.settings.money_with_currency_format || "${{amount}}";
          remaining = Math.round(remaining * 100);
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }else{
        document.querySelector('.free-shipping--text .free-shipping-remain').style.display = "none";
        document.querySelector('.free-shipping--text .free-shipping-remain-ok').style.display = "block";
      }

      free_shipping.style.setProperty('--percentage', percentage);
    }
}

function notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return false;
    }

    notes_toggle.addEventListener('click', (event) => {
      document.querySelector('.order-note-toggle__content').classList.add('active');
    });
    document.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        document.querySelector('.order-note-toggle__content').classList.remove('active');
        saveNotes();
      });
    });
  }
  
function saveNotes() {
    if(document.getElementById('mini-cart__notes').value || document.getElementById('mini-cart__name').value) {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': ':_explode_string_replace_:' + document.getElementById('mini-cart__notes').value + ':_explode_string_replace_:' +  document.getElementById('mini-cart__name').value
        })
      });
    }
  }

function removeProductEvent() {
    let removes = document.getElementById('Cart-Drawer').querySelectorAll('.remove');
    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        //updateQuantity(event.target.dataset.index, '0');
        updateQuantity(event.currentTarget.dataset.index, '0');
        event.preventDefault();
      });
    });
}

function onChange(event) {
  if (event.target.classList.contains('qty')) {
    updateQuantity(event.target.dataset.index, event.target.value);
  }
}

function updateQuantity(line, quantity) {
    document.getElementById('Cart-Drawer').querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
      document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.remove('active');
    }
  
    fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        removeProductEvent();
        notesToggle();
        updateFreeShipping();
        
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if (document.getElementById('Cart-Drawer').querySelector(`#CartDrawerItem-${line}`)) {
          document.getElementById('Cart-Drawer').querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }

        getInfoCart();
        
      });
  }

function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

function getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      }];
}

function renderContents(parsedState) {
      getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = getSectionInnerHTML(parsedState[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
}